<template>
  <div class="flex items-center">
    <vs-avatar
      :src="avatar"
      :text="avatarText"
      class="flex-shrink-0 mr-2"
      size="30px"
    />
    <p
      class="text-inherit"
    >{{ params.value }}</p
    >
  </div>
</template>

<script>
  import { storage } from "@/firebase/firebaseConfig";
  export default {
    name: "CellRendererLink",
    data() {
      return {
        avatar: null,
        avatarText: ""
      };
    },
    created() {
      if (this.params.data.pictures.length !== 0) {
        storage
          .child(this.params.data.pictures[0].thumbnail_path)
          .getDownloadURL()
          .then(response => {
            this.avatar = response;
          });
      } else {
        this.avatarText = this.params.data.name ? this.params.data.name.charAt( 0 ) : '';
      }
    },
    computed: {
      url() {
        return "/enterprise/management/user-view/" + this.params.data.user_id;
      }
    }
  };
</script>
